import { render, staticRenderFns } from "./vehicle_status_dvir_tbn.vue?vue&type=template&id=7c0ca23b&scoped=true&"
import script from "./vehicle_status_dvir_tbn.vue?vue&type=script&lang=js&"
export * from "./vehicle_status_dvir_tbn.vue?vue&type=script&lang=js&"
import style0 from "./vehicle_status_dvir_tbn.vue?vue&type=style&index=0&id=7c0ca23b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0ca23b",
  null
  
)

export default component.exports